import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  overall_data: [],
  monthly_data: [],
  daily_data: [],
  range_data: [],
};

const getters = {
  getOverallData: (state) => state.overall_data,
  getMonthlyData: (state) => state.monthly_data,
  getDailyData: (state) => state.daily_data,
  getRangeData: (state) => state.range_data,
};

const actions = {
  OVERALL_BENEF_PAYMENTS_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await axios.get(`${backend_url}/analytics/overallbenefpayments`)
        commit("GET_OVERALL_BENEF_PAYMENTS", result.data);
        resolve(result);
      } catch (err) {
        commit("DATA_ERROR");
        reject(err);
      }
    });
  },
  OVERALL_DATA_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await axios.get(`${backend_url}/analytics/overall`)
        commit("GET_OVERALL_DATA", result.data);
        resolve(result);
      } catch (err) {
        commit("DATA_ERROR");
        reject(err);
      }
    });
  },
  MONTHLY_DATA_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await axios.get(`${backend_url}/analytics/monthly`)
        commit("GET_MONTHLY_DATA", result.data);
        resolve(result);
      } catch (err) {
        commit("DATA_ERROR");
        reject(err);
      }
    });
  },
  DAILY_DATA_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await axios.get(`${backend_url}/analytics/daily`)
        commit("GET_DAILY_DATA", result.data);
        resolve(result);
      } catch (err) {
        commit("DATA_ERROR");
        reject(err);
      }
    });
  },
  CLIENT_DATA_REQUEST: ({ commit }, clientId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(
          `${backend_url}/analytics/client/${clientId}`
        );
        resolve(data);
      } catch (err) {
        commit("DATA_ERROR");
        reject(err);
      }
    });
  },
  RANGE_DATA_REQUEST: ({ commit }, { start, end }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await axios.get(`${backend_url}/analytics/range`, {
          params: { start, end },
        });
        commit("GET_RANGE_DATA", result.data);
        resolve(result);
      } catch (err) {
        commit("DATA_ERROR");
        reject(err);
      }
    });
  },
};

const mutations = {
  GET_OVERALL_BENEF_PAYMENTS: (state, data) => {
    state.overall_data = {...state.overall_data, ...data};
  },
  GET_OVERALL_DATA: (state, data) => {
    state.overall_data = data;
  },
  GET_MONTHLY_DATA: (state, data) => {
    state.monthly_data = data;
  },
  GET_DAILY_DATA: (state, data) => {
    state.daily_data = data;
  },
  GET_RANGE_DATA: (state, data) => {
    state.range_data = data;
  },
  DATA_ERROR: (state) => {
    state.overall_data = [];
    state.monthly_data = [];
    state.daily_data = [];
    state.range_data = [];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
